export const CRITICAL_SOURCE_LABELS = {
  critical: 'מקורות ממשלתיים',
  propertyInfo: 'מקורות ממשלתיים',
  plans: 'מקורות ממשלתיים',
};

export function getCriticalSourceIssues(apiErrors = {}) {
  if (!apiErrors || typeof apiErrors !== 'object') return [];

  return Object.entries(CRITICAL_SOURCE_LABELS)
    .filter(([key]) => Boolean(apiErrors[key]))
    .map(([key, label]) => ({
      key,
      label,
      message: apiErrors[key],
    }));
}

export function buildSourceHealthFromApiErrors(apiErrors = {}) {
  const criticalIssues = getCriticalSourceIssues(apiErrors);

  return {
    criticalSourceUnavailable: criticalIssues.length > 0,
    unavailableSources: criticalIssues.map((issue) => issue.label),
    criticalIssues,
  };
}

export function getLimitedDataWarningText(sourceHealth) {
  return 'אחד ממקורות המידע הרשמיים אינו זמין כרגע. נציג את הנתונים שכן הצלחנו לאסוף, אך ייתכן שהמידע חלקי. מומלץ לנסות שוב מאוחר יותר.';
}

export function getAiDisabledReasonFromSourceHealth(sourceHealth) {
  if (!sourceHealth?.criticalSourceUnavailable) return '';

  return 'דוח AI מושבת כרגע כי חסרים נתונים ממקור רשמי מרכזי. כדי להימנע מהמלצה חלקית או מטעה, מומלץ לנסות שוב כשהמקור יחזור לפעול.';
}
